import { Injectable } from '@angular/core';
import { LogService } from '@core/services/core/log.service';
import { LanguageId, SUPPORTED_LANGUAGES } from '@models/language';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LanguageContextService {

  supportedLanguages = SUPPORTED_LANGUAGES;

  selectedLanguageId$ = new BehaviorSubject<LanguageId>(this.trans.defaultLang as LanguageId);

  get selectedLanguageId() {
    return this.getSelectedLanguageId();
  }

  constructor(
    private trans: TranslateService,
    private log: LogService
  ) { }

  getSelectedLanguageId() {
    return this.selectedLanguageId$.getValue();
  }

  getSelectedLanguageIdAsObservable() {
    return this.selectedLanguageId$.asObservable();
  }

  getSupportedLanguages() {
    return this.supportedLanguages;
  }

  setLanguageToDefault() {
    this.setLanguageById(LanguageId.SPANISH);
  }

  setLanguageById(languageId: LanguageId) {
    return this.trans.use(languageId).toPromise().then(() => {
      this.selectedLanguageId$.next(languageId);
    }).catch(() => {
      this.log.e(this, `Error updating language`);
    });
  }
}
